export default {
    UILang: 'en',
    modalVisible: false,
    // modeRegistration: false,
    // modeIntroduction: false
}
